import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SpinnerHotelDirective } from '../../directives/spinner-hotel.directive';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[ctrStrokedButton]',
  imports: [MatRippleModule, MatProgressSpinnerModule, SpinnerHotelDirective],
  templateUrl: './stroked-button.component.html',
  styleUrls: ['./stroked-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrokedButtonComponent {
  @Input() load = false;
}
